import { inject, Pipe, PipeTransform } from '@angular/core';

import { Money } from '~core/models/core.models';
import { ConstantsService } from '~core/services/constants.service';

@Pipe({
  name: 'money',
  pure: true,
  standalone: true
})
export class MoneyPipe implements PipeTransform {
  private readonly _constantsService = inject(ConstantsService);

  transform(money?: Money): string {
    const currency = money?.currency || this._constantsService.defaultCurrency;
    const amountNum = Number(money?.amount);
    const amount = isNaN(amountNum) ? 0 : amountNum;

    return `${amount.toLocaleString('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      useGrouping: true
    })} ${currency}`;
  }
}
